import axios from 'axios';
const state = {

};

const getters = {

};

const actions = {
    async requestTwoFACode({ commit }, params) {
        const token = this.getters.StateToken;
        axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
        const response = await axios.post('processSendTwoFACode', params);
    },
    async check2FALogin({ commit }, params) {
        const token = this.getters.StateToken;
        axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
        const response = await axios.post('checkTwoFALogin', params);
        return response;
    },
    async resendTwoFACode({ commit }, params) {
        const token = this.getters.StateToken;
        axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
        const response = await axios.post('resendTwoFACode', params);
        return response;
    }
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/twofacode.js